export const character = {
  stats: {
    name: "xXxHaru6aToPxXx",
    level: 11,
    curHp: 363,
    maxHp: 363,
    curCp: 129,
    maxCp: 129,
    curMp: 111,
    maxMp: 111,
    exp: 124.054,
    sp: 2015,
    maxload: 100,
    load: 32.52,
    pAtk: 33,
    mAtk: 11,
    pDef: 153,
    mDef: 79,
    accuracy: 43,
    evasion: 35,
    crit: 88,
    runSpd: 159,
    pSpd: 416,
    mSpd: 213,
    str: 40,
    dex: 30,
    con: 43,
    int: 21,
    wit: 11,
    men: 25,
    karma: 0,
    pkkills: 0,
    pvpkills: 0,
    evalscore: 0,
    reqremaining: 0,
  },
  doll: {
    sHead: {
      id: 43,
      itemName: "wooden_helmet",
      icon: "armor_leather_helmet_i00",
    },
    sChest: { id: 23, itemName: "wooden_breastplate", icon: "armor_t06_u_i00" },
    sLegs: { id: 2386, itemName: "wooden_gaiters", icon: "armor_t06_l_i00" },
    sLhand: { id: 20, itemName: "buckler", icon: "shield_buckler_i00" },
    sRhand: {
      id: 7821,
      itemName: "guide_long_sword",
      icon: "weapon_long_sword_i00",
    },
    sGloves: { id: 49, itemName: "gloves", icon: "armor_t06_g_i00" },
    sFeet: { id: 1122, itemName: "cotton_shoes", icon: "armor_t50_b_i00" },
    sNeck: {
      id: 906,
      itemName: "necklace_of_knowledge",
      icon: "accessary_necklace_of_knowledge_i00",
    },
    sEar1: {
      id: 113,
      itemName: "mage_earing",
      icon: "accessary_mage_earing_i00",
    },
    sEar2: {
      id: 113,
      itemName: "mage_earing",
      icon: "accessary_mage_earing_i00",
    },
    sFinger1: {
      id: 875,
      itemName: "ring_of_knowledge",
      icon: "accessary_ring_of_knowledge_i00",
    },
    sFinger2: {
      id: 875,
      itemName: "ring_of_knowledge",
      icon: "accessary_ring_of_knowledge_i00",
    },
  },
  inventory: [
    {
      item: {
        id: 1118,
        itemName: "fungus_sac1",
        type: "questitem",
        name: "Spore Sac",
        icon: "etc_pouch_brown_i00",
      },
      count: 10,
    },
    {
      item: {
        id: 5789,
        itemName: "soulshot_none_for_rookie",
        type: "",
        name: "Soulshot: No Grade for Beginners",
        icon: "etc_soulshot_none_for_rookie_i00",
      },
      count: 4845,
    },
    {
      item: {
        id: 1869,
        itemName: "iron_ore",
        type: "",
        name: "Iron Ore",
        icon: "etc_lump_gray_i00",
      },
      count: 5,
    },
    {
      item: {
        id: 2136,
        itemName: "rp_cokes",
        type: "",
        name: "Recipe: Cokes",
        icon: "etc_recipe_white_i00",
      },
      count: 2,
    },
    {
      item: {
        id: 17,
        itemName: "wooden_arrow",
        type: "",
        name: "Wooden Arrow",
        icon: "etc_wooden_quiver_i00",
      },
      count: 245,
    },
    {
      item: {
        id: 1864,
        itemName: "stem",
        type: "",
        name: "Stem",
        icon: "etc_branch_gold_i00",
      },
      count: 12,
    },
    {
      item: {
        id: 1870,
        itemName: "coal",
        type: "",
        name: "Coal",
        icon: "etc_coal_i00",
      },
      count: 6,
    },
    {
      item: {
        id: 1872,
        itemName: "animal_bone",
        type: "",
        name: "Animal Bone",
        icon: "etc_piece_bone_white_i00",
      },
      count: 3,
    },
    {
      item: {
        id: 734,
        itemName: "quick_step_potion",
        type: "",
        name: "Haste Potion",
        icon: "etc_potion_green_i00",
      },
      count: 1,
    },
    {
      item: {
        id: 752,
        itemName: "orc_amulet",
        type: "questitem",
        name: "Orc Amulet",
        icon: "etc_feather_gold_i00",
      },
      count: 4,
    },
    {
      item: {
        id: 1086,
        itemName: "werewolf_fang",
        type: "questitem",
        name: "Werewolf's Fang",
        icon: "etc_claw_i00",
      },
      count: 2,
    },
    {
      item: {
        id: 1868,
        itemName: "thread",
        type: "",
        name: "Thread",
        icon: "etc_skein_white_i00",
      },
      count: 10,
    },
    {
      item: {
        id: 1788,
        itemName: "rp_bow",
        type: "",
        name: "Recipe: Bow",
        icon: "etc_recipe_white_i00",
      },
      count: 1,
    },
    {
      item: {
        id: 57,
        itemName: "adena",
        type: "",
        name: "Adena",
        icon: "etc_adena_i00",
      },
      count: 7084,
    },
  ],
  warehouse: [
    {
      item: {
        id: 1100,
        itemName: "cotton_tunic",
        type: "",
        name: "Cotton Tunic",
        icon: "armor_t50_u_i00",
      },
      count: 1,
    },
    {
      item: {
        id: 1103,
        itemName: "cotton_hose",
        type: "",
        name: "Cotton Stockings",
        icon: "armor_t50_l_i00",
      },
      count: 1,
    },
    {
      item: {
        id: 1666,
        itemName: "rp_wooden_arrow",
        type: "",
        name: "Recipe: Wooden Arrow",
        icon: "etc_recipe_white_i00",
      },
      count: 1,
    },
    {
      item: {
        id: 57,
        itemName: "adena",
        type: "",
        name: "Adena",
        icon: "etc_adena_i00",
      },
      count: 100,
    },
    {
      item: {
        id: 2369,
        itemName: "squire's_sword",
        type: "",
        name: "Squire's Sword",
        icon: "weapon_squires_sword_i00",
      },
      count: 1,
    },
    {
      item: {
        id: 1146,
        itemName: "squire's_shirt",
        type: "",
        name: "Squire's Shirt",
        icon: "armor_t01_u_i00",
      },
      count: 1,
    },
    {
      item: {
        id: 1147,
        itemName: "squire's_pants",
        type: "",
        name: "Squire's Pants",
        icon: "armor_t01_l_i00",
      },
      count: 1,
    },
    {
      item: {
        id: 10,
        itemName: "dagger",
        type: "",
        name: "Dagger",
        icon: "weapon_dagger_i00",
      },
      count: 1,
    },
  ],
};

export const market = [
  {
    item: {
      id: 1463,
      itemName: "soulshot_d",
      name: "Soulshot: D-grade",
      icon: "etc_spirit_bullet_blue_i00",
    },
    sellers: [
      {
        name: "OtwertkaTrade23",
        loc: "Dion Castle Town",
        price: 29,
        count: 26000,
      },
      {
        name: "Samovar",
        loc: "Dion Castle Town",
        price: 17,
        count: 67964,
      },
      {
        name: "Dioni",
        loc: "Dion Castle Town",
        price: 17,
        count: 67964,
      },
      {
        name: "Mount",
        loc: "Dion Castle Town",
        price: 17,
        count: 11842,
      },
      {
        name: "Strejcek",
        loc: "Dion Castle Town",
        price: 16,
        count: 38467,
      },
      {
        name: "BumBadaBum",
        loc: "Dion Castle Town",
        price: 16,
        count: 22052,
      },
      {
        name: "ScroogeMCDuck",
        loc: "Dion Castle Town",
        price: 16,
        count: 15220,
      },
      {
        name: "1DED1",
        loc: "Dion Castle Town",
        price: 15,
        count: 67408,
      },
    ],
    buyers: [],
  },
  {
    item: {
      id: 5575,
      itemName: "adena_of_ancient",
      name: "Ancient Adena",
      icon: "etc_ancient_adena_i00",
    },
    sellers: [
      {
        name: "Time10",
        loc: "Dion Castle Town",
        price: 14,
        count: 240012,
      },
      {
        name: "DedMoroz1",
        loc: "Dion Castle Town",
        price: 14,
        count: 99785,
      },
    ],
    buyers: [
      {
        name: "Iv101",
        loc: "Dion Castle Town",
        price: 11,
        count: 109012,
      },
    ],
  },
  {
    item: {
      id: 1867,
      itemName: "animal_skin",
      name: "Animal Skin",
      icon: "etc_leather_brown_i00",
    },
    sellers: [
      {
        name: "00004",
        loc: "Giran Castle Town",
        price: 300,
        count: 4689,
      },
      {
        name: "SpoilYorSoul",
        loc: "Giran Castle Town",
        price: 250,
        count: 4521,
      },
      {
        name: "gbt117",
        loc: "Dion Castle Town",
        price: 200,
        count: 622,
      },
    ],
    buyers: [
      {
        name: "Trader001",
        loc: "Giran Castle Town",
        price: 150,
        count: 109012,
      },
      {
        name: "Morpeh12",
        loc: "Dion Castle Town",
        price: 150,
        count: 109012,
      },
    ],
  },
  {
    item: {
      id: 1872,
      itemName: "animal_bone",
      name: "Animal Bone",
      icon: "etc_piece_bone_white_i00",
    },
    sellers: [
      {
        name: "00004",
        loc: "Giran Castle Town",
        price: 660,
        count: 1589,
      },
      {
        name: "SpoilYorSoul",
        loc: "Giran Castle Town",
        price: 650,
        count: 13450,
      },
      {
        name: "gbt117",
        loc: "Dion Castle Town",
        price: 640,
        count: 1242,
      },
      {
        name: "Maraneo",
        loc: "Giran Castle Town",
        price: 610,
        count: 1242,
      },
      {
        name: "ampola1",
        loc: "Giran Castle Town",
        price: 590,
        count: 35102,
      },
    ],
    buyers: [
      {
        name: "Trader001",
        loc: "Giran Castle Town",
        price: 460,
        count: 2531,
      },
      {
        name: "Morpeh12",
        loc: "Dion Castle Town",
        price: 450,
        count: 6524,
      },
      {
        name: "Torgashko03",
        loc: "Dion Castle Town",
        price: 433,
        count: 2345,
      },
    ],
  },
];

export const loot = [
  {
    count: 610,
    date: "2024-03-04T07:00:00.000Z",
    item: null,
    type: "SP",
  },
  {
    count: 765,
    date: "2024-03-04T08:00:00.000Z",
    item: null,
    type: "SP",
  },
  {
    count: 17867,
    date: "2024-03-04T07:00:00.000Z",
    item: null,
    type: "EXP",
  },
  {
    count: 22288,
    date: "2024-03-04T08:00:00.000Z",
    item: null,
    type: "EXP",
  },
  {
    count: 43,
    date: "2024-03-04T07:00:00.000Z",
    item: {
      id: 17,
      itemName: "wooden_arrow",
      name: "Wooden Arrow",
      icon: "etc_wooden_quiver_i00",
      type: "etcitem",
    },
    type: "ITEM",
  },
  {
    count: 202,
    date: "2024-03-04T08:00:00.000Z",
    item: {
      id: 17,
      itemName: "wooden_arrow",
      name: "Wooden Arrow",
      icon: "etc_wooden_quiver_i00",
      type: "etcitem",
    },
    type: "ITEM",
  },
  {
    count: 2954,
    date: "2024-03-04T07:00:00.000Z",
    item: {
      id: 57,
      itemName: "adena",
      name: "Adena",
      icon: "etc_adena_i00",
      type: "asset",
    },
    type: "ITEM",
  },
  {
    count: 4130,
    date: "2024-03-04T08:00:00.000Z",
    item: {
      id: 57,
      itemName: "adena",
      name: "Adena",
      icon: "etc_adena_i00",
      type: "asset",
    },
    type: "ITEM",
  },
  {
    count: 1,
    date: "2024-03-04T08:00:00.000Z",
    item: {
      id: 1100,
      itemName: "cotton_tunic",
      name: "Cotton Tunic",
      icon: "armor_t50_u_i00",
      type: "armor",
    },
    type: "ITEM",
  },
  {
    count: 1,
    date: "2024-03-04T08:00:00.000Z",
    item: {
      id: 1103,
      itemName: "cotton_hose",
      name: "Cotton Stockings",
      icon: "armor_t50_l_i00",
      type: "armor",
    },
    type: "ITEM",
  },
  {
    count: 4,
    date: "2024-03-04T07:00:00.000Z",
    item: {
      id: 1118,
      itemName: "fungus_sac1",
      name: "Spore Sac",
      icon: "etc_pouch_brown_i00",
      type: "questitem",
    },
    type: "ITEM",
  },
  {
    count: 6,
    date: "2024-03-04T08:00:00.000Z",
    item: {
      id: 1118,
      itemName: "fungus_sac1",
      name: "Spore Sac",
      icon: "etc_pouch_brown_i00",
      type: "questitem",
    },
    type: "ITEM",
  },
  {
    count: 1,
    date: "2024-03-04T07:00:00.000Z",
    item: {
      id: 1666,
      itemName: "rp_wooden_arrow",
      name: "Recipe: Wooden Arrow",
      icon: "etc_recipe_white_i00",
      type: "etcitem",
    },
    type: "ITEM",
  },
  {
    count: 3,
    date: "2024-03-04T07:00:00.000Z",
    item: {
      id: 1864,
      itemName: "stem",
      name: "Stem",
      icon: "etc_branch_gold_i00",
      type: "etcitem",
    },
    type: "ITEM",
  },
  {
    count: 1,
    date: "2024-03-04T08:00:00.000Z",
    item: {
      id: 1868,
      itemName: "thread",
      name: "Thread",
      icon: "etc_skein_white_i00",
      type: "etcitem",
    },
    type: "ITEM",
  },
  {
    count: 1,
    date: "2024-03-04T08:00:00.000Z",
    item: {
      id: 1869,
      itemName: "iron_ore",
      name: "Iron Ore",
      icon: "etc_lump_gray_i00",
      type: "etcitem",
    },
    type: "ITEM",
  },
  {
    count: 1,
    date: "2024-03-04T07:00:00.000Z",
    item: {
      id: 2136,
      itemName: "rp_cokes",
      name: "Recipe: Cokes",
      icon: "etc_recipe_white_i00",
      type: "etcitem",
    },
    type: "ITEM",
  },
  {
    count: 1,
    date: "2024-03-04T08:00:00.000Z",
    item: {
      id: 2136,
      itemName: "rp_cokes",
      name: "Recipe: Cokes",
      icon: "etc_recipe_white_i00",
      type: "etcitem",
    },
    type: "ITEM",
  },
];
